//<script type="module" src="../src/main.js"></script>
import React, { useState, useEffect, useMemo } from 'react';
import './MenuPane.less';
import { checkPNNLStaff } from './ScientiaProducts';

import AllModulesLogo from '../images/AllModulesLogo.svg';
import ProposalSubmissionLogo from '../images/ProposalSubmissionLogo.svg';
import LIMSLogo from '../images/LIMSLogo.svg';
import DataLogo from '../images/DataLogo.svg';
import ModellingWorkbenchLogo from '../images/ModelingWorkbenchLogo.svg';
import InsightEngineLogo from '../images/InsightEngineLogo.svg';
import MenuExpandArrow from '../images/MenuExpandArrow.svg';
import CloseMenu from '../images/close-menu.svg';
import OpenMenu from '../images/open-menu.svg';
import linkedin from '../images/linkedin.svg'
import facebook from '../images/facebook.svg';
import instagram from '../images/instagram.svg';
import youtube from '../images/youtube-svgrepo-com.svg';
import xplatform from  '../images/x-social-media-black-icon.svg';
import logo from "../images/EMSL_0541_BRAND_ScientiaLogo_FullLogo_ColorReversed.svg";
import white_emsl from '../images/White_EMS_ logo.svg';
import { ClipLoader } from 'react-spinners';
import JupyterHubServerModal from './JupyterHubServerModal';

interface MenuPaneProps {
    isOpen: boolean;
    onClose: () => void;
    currentUser: any;
    onExternalLinkClick: (url: string) => void;
    isTahomaUser: any;
    deleteAllJupyterHubServers: () => Promise<string>;
    getActiveJupyterHubServerList: (server:string) => Promise<boolean>;
}

interface MenuItem {
    link: string;
    text: string;
    image: string; 
    onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
    submenu?: SubmenuItem[]; 
}
  
interface SubmenuItem {
    link: string;
    text: string;
    onClick: (e: React.MouseEvent<HTMLAnchorElement>) => void;
}

export const MenuPane: React.FC<MenuPaneProps> = ({ isOpen, onClose, currentUser, onExternalLinkClick, isTahomaUser, deleteAllJupyterHubServers, getActiveJupyterHubServerList}) => {
    const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);
    const [openSubmenus, setOpenSubmenus] = useState<boolean[]>([]);
    const [highlightedIndex, setHighlightedIndex] = useState<number | null>(null);
    const [isPNNLStaff, setIsPNNLStaff] = useState<boolean>(false);
    const [activeIndex, setActiveIndex] = useState<number | null>(null);
    const [activeSubIndices, setActiveSubIndices] = useState<(number | null)[]>([]);
    // .env -> Menu Links
    const applink_proposal = process.env.REACT_APP_PROPOSAL_MANAGEMENT;
    const applink_lims = process.env.REACT_APP_LIMS;
    const applink_data = process.env.REACT_APP_DATA;
    const applink_metadata = process.env.REACT_APP_METADATA;
    const applink_ondemand = process.env.REACT_APP_ONDEMAND;
    const applink_jupyter_datascience = process.env.REACT_APP_JUPYTERHUB_DATASCIENCE;
    const applink_jupyter_tensorflow = process.env.REACT_APP_JUPYTERHUB_TENSORFLOW;
    const applink_jupyter_basic = process.env.REACT_APP_JUPYTERHUB_BASIC;
    const applink_map = process.env.REACT_APP_MAP;
    const [loadingItem, setLoadingItem] = useState<string | null>(null);
    const [showexistingServerModal, setShowExistingServerModal] = useState(false);
    const [launchUrl, setLaunchUrl] = useState<string | null>(null);
    useEffect(() => {
        setIsPNNLStaff(checkPNNLStaff(currentUser));
    }, [currentUser]);

    const menuItems: MenuItem[] = useMemo(() => {
        const handleExternalLinkClick = (url: string, e: React.MouseEvent<HTMLAnchorElement>) => {
            e.preventDefault();
            onExternalLinkClick(url);
        };
        const handleUnableToOpenInIframe = (parent_card: string, url: string, e: any) => {
            handleExternalLinkClick(parent_card, e);
            window.open(url, '_blank');
        }
        
        const handleUnableToOpenInIframeJupyter = async (itemName: string, parent_card: string, url: string, e: any) => {
            handleExternalLinkClick(parent_card, e);
            setLoadingItem(itemName);
            const same_server = await getActiveJupyterHubServerList(itemName);
            if(same_server) {
                setLaunchUrl(url);
                setShowExistingServerModal(true);
                setLoadingItem(null);
            } else {
                try {
                    const response = await deleteAllJupyterHubServers();
                    if (response === 'All servers deleted successfully') {
                        window.open(url, '_blank');
                    } else {
                        setLoadingItem(null);
                        console.error("Failed to delete servers or error occurred");
                    }
                } catch (error) {
                    setLoadingItem(null);
                    console.error("Unexpected error occurred", error);
                } finally {
                    setLoadingItem(null);
                }
            }
        }

        return [
            { link: "#", text: "All Modules", image: AllModulesLogo, onClick: (e: React.MouseEvent<HTMLAnchorElement>) => handleExternalLinkClick('ALL_CARDS', e),
                submenu: undefined
            },
            { link: "#", text: "Proposal Management", image: ProposalSubmissionLogo, onClick: (e: React.MouseEvent<HTMLAnchorElement>) => handleExternalLinkClick(applink_proposal as string, e),
                submenu: undefined
            },
            { link: "#", text: "LIMS",  
                image: LIMSLogo,
                onClick: (e: React.MouseEvent<HTMLAnchorElement>) => {
                    if (isPNNLStaff) {
                        handleExternalLinkClick('LIMS_CARDS', e);
                    } else {
                        handleExternalLinkClick(applink_metadata as string, e); 
                    }
                },
                submenu: isPNNLStaff 
                ? [
                    { link: "#", text: "Sample Submission", onClick: (e: React.MouseEvent<HTMLAnchorElement>) => handleExternalLinkClick(applink_metadata as string, e) },
                    { link: "#", text: "L7", onClick: (e: React.MouseEvent<HTMLAnchorElement>) => handleUnableToOpenInIframe('LIMS_CARDS', applink_lims as string, e) }
                  ]
                : [
                    { link: "#", text: "Sample Submission", onClick: (e: React.MouseEvent<HTMLAnchorElement>) => handleExternalLinkClick(applink_metadata as string, e) },
                ],
            },
            { link: "#", text: "Data", image: DataLogo, onClick: (e: React.MouseEvent<HTMLAnchorElement>) => handleExternalLinkClick(applink_data as string, e),
                submenu: undefined
            },
            { link: "#", text: "Modeling Workbench",
                image: ModellingWorkbenchLogo, 
                onClick: (e: React.MouseEvent<HTMLAnchorElement>) => handleExternalLinkClick('MODELING_WORKBENCH_CARDS', e),
                submenu: [
                    { link: "#", text: "Datascience", onClick: (e: React.MouseEvent<HTMLAnchorElement>) => handleUnableToOpenInIframeJupyter('datascience','MODELING_WORKBENCH_CARDS', applink_jupyter_datascience as string, e) },
                    { link: "#", text: "Tensorflow", onClick: (e: React.MouseEvent<HTMLAnchorElement>) => handleUnableToOpenInIframeJupyter('tensorflow','MODELING_WORKBENCH_CARDS', applink_jupyter_tensorflow as string, e) },
                    ...(isTahomaUser ? [{ link: "#", text: "Tahoma OnDemand", onClick: (e: React.MouseEvent<HTMLAnchorElement>) => handleUnableToOpenInIframe('MODELING_WORKBENCH_CARDS', applink_ondemand as string, e) }] : [])
                ],
            },
            { link: "#", text: "Insight Engine",
                image: InsightEngineLogo, 
                onClick: (e: React.MouseEvent<HTMLAnchorElement>) => handleExternalLinkClick('INSIGHT_ENGINE_CARDS', e),
                submenu: [
                    { link: "#", text: "Explore", onClick: (e: React.MouseEvent<HTMLAnchorElement>) => handleUnableToOpenInIframeJupyter('basic', 'INSIGHT_ENGINE_CARDS', applink_jupyter_basic as string, e) },
                    { link: "#", text: "MAP", onClick: (e: React.MouseEvent<HTMLAnchorElement>) => handleUnableToOpenInIframe('INSIGHT_ENGINE_CARDS', applink_map as string, e) }
                ],
            },
            // removing circles from menu, as there is no action determined and users might try to click and explore.
            // { link: "#", text: "Circles", image: CirclesLogo, 
            //     submenu: undefined
            // }
        ];
    }, [isPNNLStaff, applink_data, applink_jupyter_basic, applink_jupyter_datascience, applink_jupyter_tensorflow, applink_lims, applink_map, applink_metadata, applink_ondemand, applink_proposal, onExternalLinkClick, isTahomaUser]);

    useEffect(() => {
        if (openSubmenus.length !== menuItems.length) {
          setOpenSubmenus(menuItems.map(item => false)); 
        }
    }, [menuItems, openSubmenus.length]);

    useEffect(() => {
        setActiveSubIndices(Array(menuItems.length).fill(null));
    }, [menuItems.length]);

    const handleLaunch = (url: string) => {
        setShowExistingServerModal(false);
        window.open(url, '_blank');
    };

    const toggleSubmenu = (index: number) => {
        setOpenSubmenus(prevOpenSubmenus => {
            const newOpenSubmenus = [...prevOpenSubmenus];
            newOpenSubmenus[index] = !newOpenSubmenus[index];

            return newOpenSubmenus;
        });
        setActiveIndex(prevIndex => (prevIndex === index ? null : index));

        setActiveSubIndices(prevIndices => {
            const newIndices = [...prevIndices];
            newIndices[index] = null;
            return newIndices;
        });
    };

    const handleMouseEnter = (index: number) => {
        if (isOpen) {
            setHoveredIndex(index);
            setActiveIndex(prevIndex => (prevIndex === index ? null : index));
        } else { 
            setActiveIndex(index); 
        }
    };

    const handleMouseLeave = () => {
        if (isOpen) {
            setHoveredIndex(null);
        } else {
            setActiveIndex(null);
        }
    }

    useEffect(() => {
        if (!isOpen) {
          setActiveIndex(null);
          setHoveredIndex(null);
        } 
    }, [isOpen]);
 
    if (!currentUser) {
        return null;
    } else {
        return (
            <div className={`menu-pane`}>
                <nav className={`vertical-menu ${isOpen ? 'open' : 'closed'}`}>
                    {isOpen ? (
                    <>
                        <div className="close-menu" onClick={onClose}>
                            <img src={CloseMenu} alt="Close menu" />
                        </div>
                        <h3>Navigation</h3>

                        <ul className="full-menu">
                            {menuItems.map((item:MenuItem, index:number) => (
                                <React.Fragment key={index}> 
                                    <li
                                        className={`menu-link ${highlightedIndex === index ? 'highlighted' : ''} ${activeIndex === index ? 'active' : ''}`}
                                    >
                                        <a
                                            href={item.link}
                                            onMouseEnter={() => handleMouseEnter(index)}
                                            onMouseLeave={() => handleMouseLeave()}
                                            onClick={(e) => {
                                                e.stopPropagation();

                                                if (item.onClick) {
                                                    item.onClick(e);
                                                }

                                                if (item.submenu) {
                                                    toggleSubmenu(index);
                                                } 
                                                
                                                setHighlightedIndex(index);
                                                setActiveIndex(null);
                                                setActiveSubIndices(Array(menuItems.length).fill(null)); 
                                            }}
                                        >
                                            <span>
                                                {item.submenu && (<img src={MenuExpandArrow} alt="Expand menu" style={{ cursor: "pointer" }} />)}
                                            </span>
                                            <img src={item.image} alt={item.text} />
                                            {item.text}
                                        </a>
                                    </li>
                                    {item.submenu && openSubmenus[index] && (
                                        <ul className={`submenu ${openSubmenus[index] ? "active" : ""}`}>
                                            {item.submenu
                                                .filter(Boolean) 
                                                .map((subitem, subIndex: number) => (
                                                    <li 
                                                        key={subIndex} 
                                                        className={activeSubIndices[index] === subIndex ? 'highlighted active' : ''}
                                                    >
                                                        <a 
                                                            href={subitem.link}
                                                            onClick={(e: React.MouseEvent<HTMLAnchorElement>) => {
                                                                e.stopPropagation();
                                                                subitem.onClick(e);
                                                                setLoadingItem(subitem.text);
                                                                if (loadingItem && (subitem.text.toLowerCase() === loadingItem || (loadingItem === "basic" && subitem.text === "Explore"))) {
                                                                    e.preventDefault();
                                                                    return;
                                                                }
                                                                setHighlightedIndex(null);
                                                                setActiveIndex(null);
                                                                setActiveSubIndices(prevIndices => 
                                                                    prevIndices.map((value, i) => (i === index ? subIndex : null))
                                                                );
                                                            }}
                                                            style={{ pointerEvents: loadingItem === subitem.text ? 'none' : 'auto', opacity: loadingItem === subitem.text ? 0.6 : 1 }}
                                                        >
                                                            {loadingItem && (subitem.text.toLowerCase() === loadingItem || (loadingItem === "basic" && subitem.text=== "Explore")) && (
                                                                    <div className="spinner-overlay">
                                                                        <ClipLoader color="#000" loading={!!loadingItem} size={20} />
                                                                    </div>
                                                                )}
                                                            {subitem.text}
                                                        </a>
                                                    </li>
                                                ))
                                            }
                                        </ul>
                                    )}
                                    {item.image === AllModulesLogo && <div className="sidebar-divider"></div>}
                                </React.Fragment>
                            ))}
                        </ul>
                        <div className="menu-footer">
                            <div className="sidebar-divider"></div><br />
                            <div className="footer-frame" style={{justifyContent: 'flex-start', padding: '0px', marginLeft: '-10px', marginTop: '-10px'}}>
                            <div className="footer-left">
                                <div className="footer-logo-frame">
                                    <a href="https://www.emsl.pnnl.gov/" target="_blank" rel="noopener noreferrer">
                                        <img className="footer-logo" style={{width: "150px", height: "85px", marginTop: "-10px"}} src={white_emsl} alt = "logo" />
                                    </a>
                                    <p className="separator">|</p>
                                    <img className="footer-logo" style={{marginLeft: "10px"}} src={logo} alt="logo" />
                                </div>
                                <div className="footer-logo-group">

                                <a className="icon-cont" href="https://www.linkedin.com/company/environmental-molecular-sciences-laboratory-emsl-" target="_blank" rel="noopener noreferrer">
                                <img className="icon" src={linkedin} alt="linkedin" />
                                </a>

                                <a className="icon-cont" href="https://twitter.com/EMSLscience" target="_blank" rel="noopener noreferrer">
                                <img className="icon" src={xplatform} alt="x" />
                                </a>

                                <a className="icon-cont" href="https://www.facebook.com/emsl.pnnl.gov" target="_blank" rel="noopener noreferrer">
                                <img className="icon" src={facebook} alt="facebook" />
                                </a>

                                <a className="icon-cont" href="https://www.instagram.com/emslscience/" target="_blank" rel="noopener noreferrer">
                                <img className="icon" src={instagram} alt="instagram" />
                                </a>

                                <a className="icon-cont" href="http://www.youtube.com/user/EMSLatPNNL" target="_blank" rel="noopener noreferrer">
                                <img className="icon" src={youtube} alt="youtube" />
                                </a>
                                </div>
                            </div>
                            </div>
                        </div>
                    </>
                    ) : (
                    <>
                    <div className="sidebar-wrapper">
                        <div className="open-menu" onClick={onClose}>
                            <img src={OpenMenu} alt="Open menu" />
                        </div>
                        <ul className="sidebar">
                            {menuItems.map((item:MenuItem, index: number) => (
                                <li
                                key={index}
                                className={`menu-link ${highlightedIndex === index ? 'highlighted' : ''} ${activeIndex === index ? 'active' : ''}`}
                                >
                                    <a
                                        href={item.link}
                                        onClick={(e) => {
                                            e.preventDefault();
                                            setHighlightedIndex(index);
                                            if (!item.submenu) { setActiveIndex(null); }
                                            if (item.onClick) { item.onClick(e); }
                                        }}

                                        onMouseEnter={() => handleMouseEnter(index)} 
                                        onMouseLeave={() => handleMouseLeave()}
                                    >
                                        <img src={item.image} alt={item.text} />
                                    </a>
                                    {item.submenu && (
                                        <div className="submenu-wrapper">
                                            <ul className="sbsubmenu">
                                            {item.submenu
                                                .filter(Boolean)
                                                .map((subitem, subIndex: number) => (
                                                    <li key={subIndex}>
                                                        <a
                                                            href={(subitem as { link: string }).link}
                                                            onClick={(e) => {
                                                                e.preventDefault();
                                                                (subitem as { onClick: (e: React.MouseEvent<HTMLAnchorElement>) => void }).onClick(e);
                                                                if (loadingItem && (subitem.text.toLowerCase() === loadingItem || (loadingItem === "basic" && subitem.text=== "Explore"))) {
                                                                    e.preventDefault();
                                                                    return;
                                                                }
                                                                setHighlightedIndex(index);
                                                                setActiveIndex(null);
                                                            }}
                                                            style={{
                                                                pointerEvents: loadingItem && (subitem.text.toLowerCase() === loadingItem || (loadingItem === "basic" && subitem.text=== "Explore")) ? 'none' : 'auto',
                                                                opacity: loadingItem && (subitem.text.toLowerCase() === loadingItem || (loadingItem === "basic" && subitem.text=== "Explore")) ? 0.6 : 1,
                                                            }}
                                                        >
                                                            {loadingItem && (subitem.text.toLowerCase() === loadingItem || (loadingItem === "basic" && subitem.text=== "Explore")) && (
                                                                <div className="spinner-overlay">
                                                                    <ClipLoader color="#000" loading={!!loadingItem} size={20} />
                                                                </div>
                                                            )}
                                                            {(subitem as { text: string }).text}
                                                        </a>
                                                    </li>
                                                ))
                                            }
                                            </ul>
                                        </div>
                                    )}
                                    {/* Divider after All Modules */}
                                    {item.image === AllModulesLogo && <div className="sidebar-divider"></div>}
                                </li>
                            ))}
                        </ul>
                    </div>
                    </>
                )}
                </nav>
                {showexistingServerModal && (
                    <JupyterHubServerModal
                        isOpen={showexistingServerModal}
                        onClose={() => setShowExistingServerModal(false)}
                        onLaunch={() => {
                            handleLaunch(launchUrl as string);
                        }}
                    />
                )}
            </div>
        );
    }
};